import { FontSizeType } from "@tential/ec-gql-schema/models/pageParts"

export const fontSizeClasses = (pcSize: FontSizeType | string, spSize: FontSizeType | string): string[] => {
  return [`pc-${pcSize}`, `sp-${spSize}`]
}

export const alignClasses = (
  pcAlign: "" | "left" | "center" | "right" | string | null = "",
  spAlign: "" | "left" | "center" | "right" | string | null = "",
): string[] => {
  return [`pc-align-${pcAlign}`, `sp-align-${spAlign}`]
}

export const fontWeightClasses = (
  weight: "" | "normal" | "bold" | "bolder" | "lighter" | string | null = "",
): string => {
  return `weight-${weight}`
}

export const blankClasses = (
  pcMargin: "big" | "middle" | "small" | "none" | null = "big",
  spMargin: "big" | "middle" | "small" | "none" | null = "big",
): string[] => {
  return [`pc-${pcMargin}`, `sp-${spMargin}`]
}

export const detectSourceType = (isMovie = false): string => {
  return isMovie ? "movie" : ""
}
